// extracted by mini-css-extract-plugin
export default {"wrapper":"clientItem_wrapper__dMjW7","item":"clientItem_item__RVd6e","buttons":"clientItem_buttons__0hNKP"};